module.exports = __webpack_public_path__ + "static/media/contact-black.58e00bb3.svg";